import {
  ChangeEventHandler,
  forwardRef,
  type InputHTMLAttributes,
} from 'react';
import React from 'react';

export type RadioButtonProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type'
> & {
  onChange?:
    | React.ChangeEventHandler<HTMLInputElement>
    | React.MouseEventHandler<HTMLDivElement>;
};

export const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(
  ({ className, ...props }, ref) => {
    return (
      <>
        <input
          {...props}
          ref={ref}
          type="radio"
          checked={props.checked}
          className="hidden outline-none"
          onChange={props.onChange as ChangeEventHandler<HTMLInputElement>}
        />
        <div
          className={`border-ui-border bg-background-default focus:shadow-focus focus:shadow-ui-border flex h-10 w-10 cursor-pointer items-center
            justify-center rounded-full border outline-none
            ${props.disabled ? `border-ui-disabled !cursor-not-allowed` : ''}
          `}
          onClick={props.onChange as React.MouseEventHandler<HTMLDivElement>}
          role="radio"
          aria-checked={props.checked}
          tabIndex={props.tabIndex}
          onKeyDown={props.onKeyDown}
          title={props.name}
          aria-labelledby={props.name}
        >
          <div
            className={`${props.checked ? 'bg-text-body opacity-100' : 'opacity-0'} ${props.disabled && `!bg-ui-disabled`} h-5 w-5 rounded-full`}
          />
        </div>
      </>
    );
  },
);

RadioButton.displayName = 'RadioButton';
